import React, { CSSProperties, HTMLAttributes } from 'react'

import { TableBody, TableHeader } from '@/components/ui/table'
import { cn } from '@/lib/utils'
export type PageProps = HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
  style?: {
    table?: CSSProperties
    footer?: CSSProperties
  }
  pageStyle?: CSSProperties
  footer?: React.ReactNode
}

const Page: React.FC<PageProps> = ({
  className,
  children,
  style,
  ...props
}) => {
  return (
    <table
      className={cn('sheet ReferralESignatureLetterPdfPage', className)}
      {...props}
      style={style?.table}
    >
      <TableHeader style={{ height: '35px' }} />

      <TableBody>
        <div className="grow">{children}</div>
      </TableBody>

      <tfoot>
        <tr style={{ height: '35px' }}></tr>
      </tfoot>
    </table>
  )
}

export default Page
